import { ORDERS_ROUTE } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const HOME_ROUTE_NAME = 'homePage'

const routes: RouteType[] = [
    {
        path: '/',
        name: HOME_ROUTE_NAME,
        redirect: ORDERS_ROUTE
    }
]

export default routes
